import { NextPage } from 'next';
import React from 'react';
import { FdrPageComponents } from 'components/domain/fdr-page-components';
import { FdrStaticContentQuery } from 'schemas/query/static/fdr-static-content.generated';

export { getServerSideProps } from 'components/page/static/static.gssp';

interface IStaticPageProps {
  pageComponents: FdrStaticContentQuery['fdrStaticPage']['pageComponents'];
}

const StaticPage: NextPage<IStaticPageProps> = ({ pageComponents }) => {
  return <FdrPageComponents components={pageComponents?.components || []} />;
};

export default StaticPage;
